<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          contain
          :max-width="40"
          :src="require(`@/assets/conectiontab/ClickBank.png`)"
          class="ml-3 mr-2 mt-0"
        />
        <h2
          style="line-height:85px;"
          class="mr-3"
        >
          ClickBank
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          v-track="`close-click-bank-detail-drawer`"
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <v-card
        outlined
        class="update-card mb-5"
      >
        <v-row class="px-3 pt-3">
          <v-col cols="1">
            <v-icon
              color="#3FD06F"
              class="mr-3"
              size="35"
            >
              mdi-checkbox-marked-circle
            </v-icon>
          </v-col>
          <v-col class="ml-1">
            <v-row><h2>Integration Added</h2> </v-row>
            <v-row class="mt-2 pr-2">
              <p>
                You just added the ClickBank integration.
                We are syncing the data right now and you should check back in a few minutes.
                As you continue to use ClickBank,
                We will automatically keep that data in sync with Maropost.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
     <div :id="`clickbank-intergration-details`">
        <h2>Integration Info</h2>
        <v-sheet
          v-if="isLoading"
          class="pa-3"
        >
          <v-skeleton-loader
            class="mx-auto"
            type="article"
            :loading="isLoading"
          />
        </v-sheet>

        <div
          v-else
          class="mt-5 py-2 px-3 bg-grey"
        >
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Name
            </v-col>
            <v-col class="py-0">
              {{ storeData.name }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Merchant ID
            </v-col>
            <v-col class="py-0">
              {{ storeData.merchant_id }}
            </v-col>
          </v-row>
          <v-row 
            v-if="storeData.merchant_key"
            class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Maropost List
            </v-col>
            <v-col class="py-0">
              {{ storeData.list.name }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Status
            </v-col>
            <v-col class="py-0">
              <v-chip
                :color="constants.status.bounced.color"
                outlined
                small
              >
                Pending
              </v-chip>
            </v-col>
          </v-row>
          <v-row 
            v-if="storeData.notification_url"
            class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              INS URL
            </v-col>
            <v-col cols="8" class="py-0 text-truncate"
              :id="`copy-notification-ur`">
              {{ storeData.notification_url }}
            </v-col>
            <v-col cols="1" class="pt-1">
                <v-tooltip
                  right
                  color="rgba(0, 0, 0, 0.9)"
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-img
                        class="text-copy mx-2"
                        height="20"
                        width="20"
                        src="@/assets/file_copy.svg"
                        v-track="`copy-notification-url-token`"
                        @click="copyText(storeData.notification_url)"/>
                    </div>
                  </template>
                  <span>Copy address</span>
                </v-tooltip>
            </v-col>
          </v-row>
          <div class="d-flex py-4">
            <v-icon
              size="20"
              color="rgba(0, 0, 0, 0.54)"
              dark
              v-on="on"
              class="mr-4 mb-3"
            >
              mdi-information-outline
            </v-icon>
            <div class="pink-text mt-1">
              Please copy the INS URL and paste it into the Vendor Settings >> 
              Advance tools »> Instant Notification URL of the ClickBank
            </div>
          </div>
        </div>
      </div>


      <div class="my-5">
        <h2> ClickBank Fields Mapping to Maropost Fields</h2>
        <v-simple-table
          outlined
          class="mt-5 field-table"
        >
          <thead class="bg-grey">
            <tr>
              <th class="text-left">
                Maropost Fields
              </th>
              <th class="text-left">
                 ClickBank Fields
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(field, index) in clickBankFields"
              :key=" `order${index}`"
            >
              <td :class="{ 'bg-grey': field.cart == '' }">
                {{ field.maropost }}
              </td>
              <td :class="{ 'bg-grey': field.cart == '' }">
                {{ field.cart }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>

      <v-btn
        v-track="`clickbank-store-index`"
        dark
        class="mb-5"
        @click="navigateIndexPage()"
      >
        Done
      </v-btn>
    </div>
  </div>
</template>

<script>
  import constants from "@/constants.js";
  
  export default {
    name: 'ClickBankDetailDrawer',
    data () {
      return {
        isLoading: false,
        storeData: {},
        clickBankFields: [
          {
            maropost: 'For Orders:',
            cart: '',
          },
          {
            maropost: 'grand_total',
            cart: 'totalAccountAmount'
          },
          {
            maropost: 'original_order_id',
            cart: 'receipt'
          },
          {
            maropost: 'order_date',
            cart: 'transactionTime'
          },
          {
            maropost: 'order_status',
            cart: 'transactionType'
          },
          {
            maropost: 'For Contacts:',
            cart: '',
          },
          {
            maropost: 'first_name',
            cart: 'firstName'
          },
          {
            maropost: 'last_name',
            cart: 'lastName'
          },
          {
            maropost: 'email',
            cart: 'email'
          },
          {
            maropost: 'For Contacts Field:',
            cart: '',
          },
          {
            maropost: 'transactionType',
            cart: 'transactionType'
          },
          {
            maropost: 'For Order Items:',
            cart: '',
          },
          {
            maropost: 'item_id',
            cart: 'itemNo'
          },
          {
            maropost: 'quantity',
            cart: 'nil'
          },
          {
            maropost: 'description',
            cart: 'productTitle'
          },
          {
            maropost: 'price',
            cart: 'accountAmount'
          },
          {
            maropost: "Custom Fields",
            cart: ""
          },
        ],
        isMounted: false,
        constants: constants
      }
    },
    mounted() {
      this.isLoading  = true;
      const data = this.$store.getters['ui/drawer'].right.storeData
      if (data) {
        this.storeData = data;
        Object.keys(this.storeData.mapped_fields).forEach(key => {
          this.clickBankFields.push({maropost: key, cart: this.storeData.mapped_fields[key]})
        });
      }
      this.isLoading  = false
      this.isMounted  = true;
    },
    beforeDestroy () {
      this.isMounted = false
      this.navigateIndexPage()
    },
    methods: {
      navigateIndexPage () {
        this.$store.getters['ui/drawer'].right.show = false
        this.$store.getters['ui/drawer'].right.fetchRecords();
      },
      copyText (value) {
        try {
          const el = document.createElement('textarea');
          el.value = value;
          document.body.appendChild(el);
          el.select();
          var successful = document.execCommand('copy');
          document.body.removeChild(el);
          var msg = successful ? 'success' : 'error'
          this.$store.commit('ui/snackbar', {
            message: 'Notification URL is copied to clipboard',
            type: msg,
            timeout: 2000,
          })
        } catch (error) {
          this.$store.commit('ui/snackbar', {
            message: 'Error copying',
            type: 'error',
            timeout: 2000,
          })
        }
      },
    },
  }
</script>

<style scoped>
.bg-grey {
  background-color: #f4f4f4;
}
.update-card{
  border: 1px solid #3BCF6C !important;
}
.field-table{
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.text-copy{
  cursor: pointer;
}
.pink-text {
  color: #F53BAD
}
</style>
